<template>
  <button class="ss-button text-nowrap" :class="`${this.$store.state.brand.name} ${this.flavor}`" v-on:click="CtaAction()">{{ brandButtonText }}</button>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'ScheduleServiceButton',
  props: {
    couponId: String,
    source: String,
    flavor: {
      type: String,
      default: 'primary',
      validator: function (value) {
        return ['primary', 'secondary', 'hero'].indexOf(value) !== -1
      }
    },
    cta: {
      type: String,
      default: 'schedule'
    }
  },
  computed: {
    ...mapState({
      brand: state => state.brand,
      dealer: state => state.dealer
    }),
    ...mapGetters({
      scheduleEnabled: 'scheduleEnabled'
    }),
    brandButtonText () {
      let result
      if (this.cta === 'schedule') {
        if (this.brand.name === 'mini') {
          result = 'Schedule An Appointment'
        } else {
          result = 'Schedule Service'
        }
      } else {
        result = 'Learn More'
      }
      return result
    }
  },
  methods: {
    CtaAction: function () {
      if (this.cta === 'schedule') {
        if (this.scheduleEnabled) {
          this.$store.commit('appointment/setClickedOnOffer', { coupon: this.couponId, source: this.source })
          this.$nextTick(() => { this.$router.replace({ name: 'appointment' }).catch(() => {}) })
        } else {
          // if schedule is not enabled open dealer appointment link in new tab
          window.open(this.dealer.url.appointment, '_blank')
        }
      } else {
        this.$emit('ctaAction')
      }
    }
  }
}
</script>

<style scoped>
/* styles for xs screens go here */
/* styles for different screen widths follow */
@media only screen and (min-width: 576px) {
}
@media only screen and (min-width: 768px) {
}
@media only screen and (min-width: 992px) {
}
@media only screen and (min-width: 1200px) {
}
</style>
